"use client";
import { openChatBotFunction } from "@/lib/utils";
import React from "react";

const LiveChat = ({ text = "Live Chat", children }) => {
  return (
    <div onClick={openChatBotFunction} className="cursor-pointer flex align-center justify-center">
      {children ? children : <p>{text}</p>}
    </div>
  );
};

export default LiveChat;
